import { render, staticRenderFns } from "./ScriptsInventory.vue?vue&type=template&id=06e5b690&scoped=true"
import script from "./ScriptsInventory.vue?vue&type=script&lang=js"
export * from "./ScriptsInventory.vue?vue&type=script&lang=js"
import style0 from "./ScriptsInventory.vue?vue&type=style&index=0&id=06e5b690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e5b690",
  null
  
)

export default component.exports